import { ArrowBack } from "@material-ui/icons";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import axios from "axios";
import {
  CurrencyDisplay,
  CustomTable,
  ModalError,
  SearchTextInput,
} from "components";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";

const ModalListComposer = ({ open, onClose }) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/publisher/transaction/v2/balance/composer`,
        {
          headers,
          params: queryParams,
        }
      );
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  const columnTable = [
    {
      name: "composer_id",
      title: "ID Composer",
      useSort: true,
      sort_key: "composer_id",
    },
    {
      name: "composer_name",
      title: "Composer Name",
      useSort: true,
      sort_key: "composer_name",
    },
    {
      name: "all",
      title: "Value",
      headerAlign: "right",
      useSort: true,
      sort_key: "balance",
      renderText: item => (
        <CurrencyDisplay
          value={item?.balance}
          decimalScale={2}
          suffix=",-"
          prefix={"Rp"}
        />
      ),
    },
  ];

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={true}
    >
      <DialogTitle>
        <Grid container columnGap={1} alignItems="center">
          <Grid item>
            <IconButton onClick={onClose}>
              <ArrowBack />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography fontSize={24} fontWeight={700}>
              List Composer
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <SearchTextInput
          fullWidth
          placeholder="Search"
          value={queryParams?.search}
          onChange={e => {
            handleChangeQueryParams(e?.target?.value, "search");
          }}
        />
        <Box mt="16px">
          <CustomTable
            isLoading={loadingPage}
            columnTable={columnTable}
            data={dataTable}
            page={queryParams?.page}
            pageSize={queryParams?.size}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "size")
            }
            pageSizeList={pageSizeList}
            onRequestSort={sortBy => {
              return handleChangeQueryParams(
                `${sortBy} ${
                  queryParams?.sort === `${sortBy} asc` ? "desc" : "asc"
                }`,
                "sort"
              );
            }}
            sortValue={queryParams?.sort}
            maxHeight={500}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
const pageSizeList = [
  { name: 5 },
  { name: 10 },
  { name: 20 },
  { name: 50 },
  { name: 100 },
];

export default ModalListComposer;
